<template>
  <div class="page-wrapper">
    <div class="page-head">
      <h1>{{ $vuetify.lang.t('$vuetify.menu.clients') }}</h1>

      <div class="page-head__buttons">
        <button class="btn-secondary btn btn-min" @click="arch = !arch; page=1">
          <span v-if="!arch">{{ $vuetify.lang.t('$vuetify.archive') }}</span>
          <span v-else>{{ $vuetify.lang.t('$vuetify.outArchive') }}</span>
        </button>
        <button v-if="permissions.edit.indexOf('Клиенты') !== -1" class="btn-secondary btn" @click="client_create_open">
          + {{ $vuetify.lang.t('$vuetify.addClient') }}
        </button>
      </div>
    </div>

    <div class="page-head page-head--sorts">
      <div class="page__sorts">
        <v-text-field class="search-field" v-model="search" @keypress.enter="page=1; loadData()"
                      :placeholder="$vuetify.lang.t('$vuetify.sorts.searchMan')" outlined
                      prepend-inner-icon="$search" hide-details>
        </v-text-field>
        <v-select class="sorts__select" :class="{ show: type === 'cards' }" v-model="sort" attach
                  :label="$vuetify.lang.t('$vuetify.dataTable.sortBy')"
                  :items="selectSorts" item-text="name" item-value="value"
                  :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                      maxHeight: 200,
                                      contentClass: 'select-menu select-menu--sort',
                                  }" outlined hide-details>
          <template v-slot:selection="{item }">
            {{ $vuetify.lang.t("$vuetify.sorts." + item.type) }}
            {{ $vuetify.lang.t("$vuetify." + item.direction) }}
          </template>
          <template v-slot:item="{ item }">
            {{ $vuetify.lang.t("$vuetify.sorts." + item.type) }}
            {{ $vuetify.lang.t("$vuetify." + item.direction) }}
          </template>
        </v-select>
      </div>
      <div class="page-head--right">
        <per-page-select v-model="perPage"></per-page-select>
        <div class="type-switcher">
          <div class="type-switcher__item" :class="{ show: type === 'rows' }" @click="type = 'rows'">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5"/>
              <path
                d="M9.20039 9.7998C8.723 9.7998 8.26516 9.98945 7.9276 10.327C7.59003 10.6646 7.40039 11.1224 7.40039 11.5998V13.9998C7.40039 14.4772 7.59003 14.935 7.9276 15.2726C8.26516 15.6102 8.723 15.7998 9.20039 15.7998H11.6004C12.0778 15.7998 12.5356 15.6102 12.8732 15.2726C13.2107 14.935 13.4004 14.4772 13.4004 13.9998V11.5998C13.4004 11.1224 13.2107 10.6646 12.8732 10.327C12.5356 9.98945 12.0778 9.7998 11.6004 9.7998H9.20039ZM8.60039 11.5998C8.60039 11.4407 8.6636 11.2881 8.77613 11.1755C8.88865 11.063 9.04126 10.9998 9.20039 10.9998H11.6004C11.7595 10.9998 11.9121 11.063 12.0247 11.1755C12.1372 11.2881 12.2004 11.4407 12.2004 11.5998V13.9998C12.2004 14.1589 12.1372 14.3115 12.0247 14.4241C11.9121 14.5366 11.7595 14.5998 11.6004 14.5998H9.20039C9.04126 14.5998 8.88865 14.5366 8.77613 14.4241C8.6636 14.3115 8.60039 14.1589 8.60039 13.9998V11.5998ZM16.4004 10.9998C16.2413 10.9998 16.0886 11.063 15.9761 11.1755C15.8636 11.2881 15.8004 11.4407 15.8004 11.5998C15.8004 11.7589 15.8636 11.9115 15.9761 12.0241C16.0886 12.1366 16.2413 12.1998 16.4004 12.1998H26.0004C26.1595 12.1998 26.3121 12.1366 26.4247 12.0241C26.5372 11.9115 26.6004 11.7589 26.6004 11.5998C26.6004 11.4407 26.5372 11.2881 26.4247 11.1755C26.3121 11.063 26.1595 10.9998 26.0004 10.9998H16.4004ZM16.4004 13.3998C16.2413 13.3998 16.0886 13.463 15.9761 13.5755C15.8636 13.6881 15.8004 13.8407 15.8004 13.9998C15.8004 14.1589 15.8636 14.3115 15.9761 14.4241C16.0886 14.5366 16.2413 14.5998 16.4004 14.5998H23.6004C23.7595 14.5998 23.9121 14.5366 24.0247 14.4241C24.1372 14.3115 24.2004 14.1589 24.2004 13.9998C24.2004 13.8407 24.1372 13.6881 24.0247 13.5755C23.9121 13.463 23.7595 13.3998 23.6004 13.3998H16.4004ZM9.20039 18.1998C8.723 18.1998 8.26516 18.3894 7.9276 18.727C7.59003 19.0646 7.40039 19.5224 7.40039 19.9998V22.3998C7.40039 22.8772 7.59003 23.335 7.9276 23.6726C8.26516 24.0102 8.723 24.1998 9.20039 24.1998H11.6004C12.0778 24.1998 12.5356 24.0102 12.8732 23.6726C13.2107 23.335 13.4004 22.8772 13.4004 22.3998V19.9998C13.4004 19.5224 13.2107 19.0646 12.8732 18.727C12.5356 18.3894 12.0778 18.1998 11.6004 18.1998H9.20039ZM8.60039 19.9998C8.60039 19.8407 8.6636 19.6881 8.77613 19.5755C8.88865 19.463 9.04126 19.3998 9.20039 19.3998H11.6004C11.7595 19.3998 11.9121 19.463 12.0247 19.5755C12.1372 19.6881 12.2004 19.8407 12.2004 19.9998V22.3998C12.2004 22.5589 12.1372 22.7115 12.0247 22.8241C11.9121 22.9366 11.7595 22.9998 11.6004 22.9998H9.20039C9.04126 22.9998 8.88865 22.9366 8.77613 22.8241C8.6636 22.7115 8.60039 22.5589 8.60039 22.3998V19.9998ZM16.4004 19.3998C16.2413 19.3998 16.0886 19.463 15.9761 19.5755C15.8636 19.6881 15.8004 19.8407 15.8004 19.9998C15.8004 20.1589 15.8636 20.3115 15.9761 20.4241C16.0886 20.5366 16.2413 20.5998 16.4004 20.5998H26.0004C26.1595 20.5998 26.3121 20.5366 26.4247 20.4241C26.5372 20.3115 26.6004 20.1589 26.6004 19.9998C26.6004 19.8407 26.5372 19.6881 26.4247 19.5755C26.3121 19.463 26.1595 19.3998 26.0004 19.3998H16.4004ZM16.4004 21.7998C16.2413 21.7998 16.0886 21.863 15.9761 21.9755C15.8636 22.0881 15.8004 22.2407 15.8004 22.3998C15.8004 22.5589 15.8636 22.7115 15.9761 22.8241C16.0886 22.9366 16.2413 22.9998 16.4004 22.9998H23.6004C23.7595 22.9998 23.9121 22.9366 24.0247 22.8241C24.1372 22.7115 24.2004 22.5589 24.2004 22.3998C24.2004 22.2407 24.1372 22.0881 24.0247 21.9755C23.9121 21.863 23.7595 21.7998 23.6004 21.7998H16.4004Z"
                fill="#2A3F57"/>
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
            </svg>
          </div>
          <div class="type-switcher__item" :class="{ show: type === 'cards' }" @click="type = 'cards'">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M15.5738 8.86902C14.9918 8.3126 14.2024 8 13.3793 8H11.1034C10.2804 8 9.49099 8.3126 8.90898 8.86902C8.32697 9.42545 8 10.1801 8 10.967V13.5385C8 14.3254 8.32697 15.08 8.90898 15.6365C9.49099 16.1929 10.2804 16.5055 11.1034 16.5055H13.3793C14.2024 16.5055 14.9918 16.1929 15.5738 15.6365C16.1558 15.08 16.4828 14.3254 16.4828 13.5385V10.967C16.4828 10.1801 16.1558 9.42545 15.5738 8.86902ZM9.24138 13.5385V10.967C9.24138 10.4949 9.43756 10.0421 9.78677 9.70823C10.136 9.37437 10.6096 9.18681 11.1034 9.18681H13.3793C13.8732 9.18681 14.3468 9.37437 14.696 9.70823C15.0452 10.0421 15.2414 10.4949 15.2414 10.967V13.5385C15.2414 14.0106 15.0452 14.4634 14.696 14.7973C14.3468 15.1311 13.8732 15.3187 13.3793 15.3187H11.1034C10.6096 15.3187 10.136 15.1311 9.78677 14.7973C9.43756 14.4634 9.24138 14.0106 9.24138 13.5385Z"
                    fill="#2A3F57"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M25.091 8.86902C24.509 8.3126 23.7196 8 22.8966 8H20.6207C19.7976 8 19.0082 8.3126 18.4262 8.86902C17.8442 9.42545 17.5172 10.1801 17.5172 10.967V13.5385C17.5172 14.3254 17.8442 15.08 18.4262 15.6365C19.0082 16.1929 19.7976 16.5055 20.6207 16.5055H22.8966C23.7196 16.5055 24.509 16.1929 25.091 15.6365C25.673 15.08 26 14.3254 26 13.5385V10.967C26 10.1801 25.673 9.42545 25.091 8.86902ZM18.7586 13.5385V10.967C18.7586 10.4949 18.9548 10.0421 19.304 9.70823C19.6532 9.37437 20.1268 9.18681 20.6207 9.18681H22.8966C23.3904 9.18681 23.864 9.37437 24.2132 9.70823C24.5624 10.0421 24.7586 10.4949 24.7586 10.967V13.5385C24.7586 14.0106 24.5624 14.4634 24.2132 14.7973C23.864 15.1311 23.3904 15.3187 22.8966 15.3187H20.6207C20.1268 15.3187 19.6532 15.1311 19.304 14.7973C18.9548 14.4634 18.7586 14.0106 18.7586 13.5385Z"
                    fill="#2A3F57"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M15.5738 18.3635C14.9918 17.8071 14.2024 17.4945 13.3793 17.4945H11.1034C10.2804 17.4945 9.49099 17.8071 8.90898 18.3635C8.32697 18.92 8 19.6746 8 20.4615V23.033C8 23.8199 8.32697 24.5745 8.90898 25.131C9.49099 25.6874 10.2804 26 11.1034 26H13.3793C14.2024 26 14.9918 25.6874 15.5738 25.131C16.1558 24.5745 16.4828 23.8199 16.4828 23.033V20.4615C16.4828 19.6746 16.1558 18.92 15.5738 18.3635ZM9.24138 23.033V20.4615C9.24138 19.9894 9.43756 19.5366 9.78677 19.2027C10.136 18.8689 10.6096 18.6813 11.1034 18.6813H13.3793C13.8732 18.6813 14.3468 18.8689 14.696 19.2027C15.0452 19.5366 15.2414 19.9894 15.2414 20.4615V23.033C15.2414 23.5051 15.0452 23.9579 14.696 24.2918C14.3468 24.6256 13.8732 24.8132 13.3793 24.8132H11.1034C10.6096 24.8132 10.136 24.6256 9.78677 24.2918C9.43756 23.9579 9.24138 23.5051 9.24138 23.033Z"
                    fill="#2A3F57"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M25.091 18.3635C24.509 17.8071 23.7196 17.4945 22.8966 17.4945H20.6207C19.7976 17.4945 19.0082 17.8071 18.4262 18.3635C17.8442 18.92 17.5172 19.6746 17.5172 20.4615V23.033C17.5172 23.8199 17.8442 24.5745 18.4262 25.131C19.0082 25.6874 19.7976 26 20.6207 26H22.8966C23.7196 26 24.509 25.6874 25.091 25.131C25.673 24.5745 26 23.8199 26 23.033V20.4615C26 19.6746 25.673 18.92 25.091 18.3635ZM18.7586 23.033V20.4615C18.7586 19.9894 18.9548 19.5366 19.304 19.2027C19.6532 18.8689 20.1268 18.6813 20.6207 18.6813H22.8966C23.3904 18.6813 23.864 18.8689 24.2132 19.2027C24.5624 19.5366 24.7586 19.9894 24.7586 20.4615V23.033C24.7586 23.5051 24.5624 23.9579 24.2132 24.2918C23.864 24.6256 23.3904 24.8132 22.8966 24.8132H20.6207C20.1268 24.8132 19.6532 24.6256 19.304 24.2918C18.9548 23.9579 18.7586 23.5051 18.7586 23.033Z"
                    fill="#2A3F57"/>
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
            </svg>
          </div>
          <div class="type-switcher__item type-switcher__item--settings" @click="settingsModal=true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="path-1-inside-1_1733_6915" fill="white">
                <path
                  d="M2.29162 8.85988C2.73501 7.49078 3.4634 6.23113 4.42882 5.16388C4.50861 5.0757 4.61281 5.01322 4.72819 4.98437C4.84356 4.95553 4.96491 4.96162 5.07682 5.00188L7.37842 5.82508C7.54227 5.88359 7.71688 5.90577 7.89016 5.89008C8.06343 5.8744 8.23122 5.82122 8.3819 5.73423C8.53258 5.64725 8.66254 5.52854 8.76278 5.38634C8.86302 5.24413 8.93114 5.08183 8.96242 4.91068L9.40042 2.50348C9.42163 2.3863 9.47723 2.27808 9.56014 2.1926C9.64306 2.10712 9.74953 2.04825 9.86602 2.02348C11.2722 1.72394 12.7258 1.72394 14.132 2.02348C14.2485 2.04825 14.355 2.10712 14.4379 2.1926C14.5208 2.27808 14.5764 2.3863 14.5976 2.50348L15.0368 4.91068C15.0681 5.08183 15.1362 5.24413 15.2364 5.38634C15.3367 5.52854 15.4666 5.64725 15.6173 5.73423C15.768 5.82122 15.9358 5.8744 16.1091 5.89008C16.2823 5.90577 16.457 5.88359 16.6208 5.82508L18.9236 5.00188C19.0355 4.96202 19.1566 4.95626 19.2718 4.98531C19.3869 5.01436 19.4909 5.07693 19.5704 5.16508C20.5353 6.23209 21.2632 7.4913 21.7064 8.85988C21.743 8.97293 21.7452 9.09429 21.7127 9.20858C21.6802 9.32288 21.6146 9.42495 21.524 9.50188L19.658 11.0859C19.5255 11.1985 19.419 11.3387 19.346 11.4965C19.2729 11.6544 19.2351 11.8263 19.2351 12.0003C19.2351 12.1742 19.2729 12.3461 19.346 12.504C19.419 12.6619 19.5255 12.802 19.658 12.9147L21.524 14.4987C21.6146 14.5756 21.6802 14.6777 21.7127 14.792C21.7452 14.9063 21.743 15.0276 21.7064 15.1407C21.2634 16.5097 20.5354 17.7693 19.5704 18.8367C19.4906 18.9249 19.3864 18.9873 19.271 19.0162C19.1557 19.045 19.0343 19.0389 18.9224 18.9987L16.6208 18.1755C16.457 18.117 16.2823 18.0948 16.1091 18.1105C15.9358 18.1262 15.768 18.1793 15.6173 18.2663C15.4666 18.3533 15.3367 18.472 15.2364 18.6142C15.1362 18.7564 15.0681 18.9187 15.0368 19.0899L14.5964 21.4983C14.5751 21.6151 14.5195 21.7229 14.4369 21.8082C14.3542 21.8934 14.2481 21.9522 14.132 21.9771C12.7258 22.2767 11.2722 22.2767 9.86602 21.9771C9.74953 21.9523 9.64306 21.8934 9.56014 21.808C9.47723 21.7225 9.42163 21.6143 9.40042 21.4971L8.96242 19.0899C8.93114 18.9187 8.86302 18.7564 8.76278 18.6142C8.66254 18.472 8.53258 18.3533 8.3819 18.2663C8.23122 18.1793 8.06343 18.1262 7.89016 18.1105C7.71688 18.0948 7.54227 18.117 7.37842 18.1755L5.07562 18.9987C4.96376 19.0385 4.84258 19.0443 4.72744 19.0152C4.61231 18.9862 4.50838 18.9236 4.42882 18.8355C3.46395 17.7685 2.73598 16.5093 2.29282 15.1407C2.25623 15.0276 2.25404 14.9063 2.28651 14.792C2.31899 14.6777 2.38466 14.5756 2.47522 14.4987L4.34122 12.9147C4.47377 12.802 4.58025 12.6619 4.65328 12.504C4.7263 12.3461 4.76412 12.1742 4.76412 12.0003C4.76412 11.8263 4.7263 11.6544 4.65328 11.4965C4.58025 11.3387 4.47377 11.1985 4.34122 11.0859L2.47522 9.50188C2.38466 9.42495 2.31899 9.32288 2.28651 9.20858C2.25404 9.09429 2.25623 8.97293 2.29282 8.85988H2.29162ZM3.56482 8.85268L5.11761 10.1703C5.38314 10.3956 5.59646 10.676 5.74276 10.992C5.88906 11.308 5.96484 11.652 5.96484 12.0003C5.96484 12.3485 5.88906 12.6926 5.74276 13.0086C5.59646 13.3246 5.38314 13.605 5.11761 13.8303L3.56482 15.1479C3.91522 16.0863 4.42162 16.9599 5.05882 17.7303L6.97401 17.0463C7.3018 16.9293 7.65112 16.8849 7.99774 16.9164C8.34436 16.9478 8.68 17.0543 8.98137 17.2284C9.28275 17.4025 9.54266 17.64 9.74307 17.9246C9.94349 18.2091 10.0796 18.5339 10.142 18.8763L10.508 20.8779C11.4952 21.0425 12.5028 21.0425 13.49 20.8779L13.856 18.8739C13.9186 18.5316 14.0548 18.207 14.2553 17.9226C14.4558 17.6382 14.7157 17.4007 15.017 17.2268C15.3184 17.0528 15.654 16.9464 16.0005 16.9151C16.3471 16.8837 16.6963 16.9281 17.024 17.0451L18.9404 17.7303C19.5788 16.9587 20.0837 16.0859 20.4344 15.1479L18.8816 13.8303C18.6157 13.6052 18.4021 13.3249 18.2555 13.0089C18.109 12.6928 18.0331 12.3486 18.0331 12.0003C18.0331 11.6519 18.109 11.3077 18.2555 10.9917C18.4021 10.6757 18.6157 10.3954 18.8816 10.1703L20.4344 8.85268C20.0838 7.91466 19.5788 7.04184 18.9404 6.27028L17.0252 6.95428C16.6975 7.0713 16.3483 7.11566 16.0017 7.08428C15.6552 7.05291 15.3196 6.94656 15.0182 6.77259C14.7169 6.59862 14.457 6.36121 14.2565 6.0768C14.056 5.79238 13.9198 5.46778 13.8572 5.12548L13.49 3.12268C12.5028 2.95809 11.4952 2.95809 10.508 3.12268L10.1432 5.12548C10.0808 5.46789 9.94469 5.79262 9.74427 6.07718C9.54386 6.36173 9.28395 6.59928 8.98257 6.77338C8.6812 6.94747 8.34556 7.05393 7.99894 7.08537C7.65232 7.11682 7.303 7.07249 6.97522 6.95548L5.05882 6.27028C4.42045 7.04185 3.9155 7.91467 3.56482 8.85268ZM8.99962 12.0003C8.99962 11.2046 9.31569 10.4416 9.87829 9.87896C10.4409 9.31635 11.204 9.00028 11.9996 9.00028C12.7953 9.00028 13.5583 9.31635 14.1209 9.87896C14.6835 10.4416 14.9996 11.2046 14.9996 12.0003C14.9996 12.7959 14.6835 13.559 14.1209 14.1216C13.5583 14.6842 12.7953 15.0003 11.9996 15.0003C11.204 15.0003 10.4409 14.6842 9.87829 14.1216C9.31569 13.559 8.99962 12.7959 8.99962 12.0003ZM10.1996 12.0003C10.1996 12.4777 10.3893 12.9355 10.7268 13.2731C11.0644 13.6106 11.5222 13.8003 11.9996 13.8003C12.477 13.8003 12.9348 13.6106 13.2724 13.2731C13.61 12.9355 13.7996 12.4777 13.7996 12.0003C13.7996 11.5229 13.61 11.0651 13.2724 10.7275C12.9348 10.3899 12.477 10.2003 11.9996 10.2003C11.5222 10.2003 11.0644 10.3899 10.7268 10.7275C10.3893 11.0651 10.1996 11.5229 10.1996 12.0003Z"/>
              </mask>
              <path
                d="M2.29162 8.85988C2.73501 7.49078 3.4634 6.23113 4.42882 5.16388C4.50861 5.0757 4.61281 5.01322 4.72819 4.98437C4.84356 4.95553 4.96491 4.96162 5.07682 5.00188L7.37842 5.82508C7.54227 5.88359 7.71688 5.90577 7.89016 5.89008C8.06343 5.8744 8.23122 5.82122 8.3819 5.73423C8.53258 5.64725 8.66254 5.52854 8.76278 5.38634C8.86302 5.24413 8.93114 5.08183 8.96242 4.91068L9.40042 2.50348C9.42163 2.3863 9.47723 2.27808 9.56014 2.1926C9.64306 2.10712 9.74953 2.04825 9.86602 2.02348C11.2722 1.72394 12.7258 1.72394 14.132 2.02348C14.2485 2.04825 14.355 2.10712 14.4379 2.1926C14.5208 2.27808 14.5764 2.3863 14.5976 2.50348L15.0368 4.91068C15.0681 5.08183 15.1362 5.24413 15.2364 5.38634C15.3367 5.52854 15.4666 5.64725 15.6173 5.73423C15.768 5.82122 15.9358 5.8744 16.1091 5.89008C16.2823 5.90577 16.457 5.88359 16.6208 5.82508L18.9236 5.00188C19.0355 4.96202 19.1566 4.95626 19.2718 4.98531C19.3869 5.01436 19.4909 5.07693 19.5704 5.16508C20.5353 6.23209 21.2632 7.4913 21.7064 8.85988C21.743 8.97293 21.7452 9.09429 21.7127 9.20858C21.6802 9.32288 21.6146 9.42495 21.524 9.50188L19.658 11.0859C19.5255 11.1985 19.419 11.3387 19.346 11.4965C19.2729 11.6544 19.2351 11.8263 19.2351 12.0003C19.2351 12.1742 19.2729 12.3461 19.346 12.504C19.419 12.6619 19.5255 12.802 19.658 12.9147L21.524 14.4987C21.6146 14.5756 21.6802 14.6777 21.7127 14.792C21.7452 14.9063 21.743 15.0276 21.7064 15.1407C21.2634 16.5097 20.5354 17.7693 19.5704 18.8367C19.4906 18.9249 19.3864 18.9873 19.271 19.0162C19.1557 19.045 19.0343 19.0389 18.9224 18.9987L16.6208 18.1755C16.457 18.117 16.2823 18.0948 16.1091 18.1105C15.9358 18.1262 15.768 18.1793 15.6173 18.2663C15.4666 18.3533 15.3367 18.472 15.2364 18.6142C15.1362 18.7564 15.0681 18.9187 15.0368 19.0899L14.5964 21.4983C14.5751 21.6151 14.5195 21.7229 14.4369 21.8082C14.3542 21.8934 14.2481 21.9522 14.132 21.9771C12.7258 22.2767 11.2722 22.2767 9.86602 21.9771C9.74953 21.9523 9.64306 21.8934 9.56014 21.808C9.47723 21.7225 9.42163 21.6143 9.40042 21.4971L8.96242 19.0899C8.93114 18.9187 8.86302 18.7564 8.76278 18.6142C8.66254 18.472 8.53258 18.3533 8.3819 18.2663C8.23122 18.1793 8.06343 18.1262 7.89016 18.1105C7.71688 18.0948 7.54227 18.117 7.37842 18.1755L5.07562 18.9987C4.96376 19.0385 4.84258 19.0443 4.72744 19.0152C4.61231 18.9862 4.50838 18.9236 4.42882 18.8355C3.46395 17.7685 2.73598 16.5093 2.29282 15.1407C2.25623 15.0276 2.25404 14.9063 2.28651 14.792C2.31899 14.6777 2.38466 14.5756 2.47522 14.4987L4.34122 12.9147C4.47377 12.802 4.58025 12.6619 4.65328 12.504C4.7263 12.3461 4.76412 12.1742 4.76412 12.0003C4.76412 11.8263 4.7263 11.6544 4.65328 11.4965C4.58025 11.3387 4.47377 11.1985 4.34122 11.0859L2.47522 9.50188C2.38466 9.42495 2.31899 9.32288 2.28651 9.20858C2.25404 9.09429 2.25623 8.97293 2.29282 8.85988H2.29162ZM3.56482 8.85268L5.11761 10.1703C5.38314 10.3956 5.59646 10.676 5.74276 10.992C5.88906 11.308 5.96484 11.652 5.96484 12.0003C5.96484 12.3485 5.88906 12.6926 5.74276 13.0086C5.59646 13.3246 5.38314 13.605 5.11761 13.8303L3.56482 15.1479C3.91522 16.0863 4.42162 16.9599 5.05882 17.7303L6.97401 17.0463C7.3018 16.9293 7.65112 16.8849 7.99774 16.9164C8.34436 16.9478 8.68 17.0543 8.98137 17.2284C9.28275 17.4025 9.54266 17.64 9.74307 17.9246C9.94349 18.2091 10.0796 18.5339 10.142 18.8763L10.508 20.8779C11.4952 21.0425 12.5028 21.0425 13.49 20.8779L13.856 18.8739C13.9186 18.5316 14.0548 18.207 14.2553 17.9226C14.4558 17.6382 14.7157 17.4007 15.017 17.2268C15.3184 17.0528 15.654 16.9464 16.0005 16.9151C16.3471 16.8837 16.6963 16.9281 17.024 17.0451L18.9404 17.7303C19.5788 16.9587 20.0837 16.0859 20.4344 15.1479L18.8816 13.8303C18.6157 13.6052 18.4021 13.3249 18.2555 13.0089C18.109 12.6928 18.0331 12.3486 18.0331 12.0003C18.0331 11.6519 18.109 11.3077 18.2555 10.9917C18.4021 10.6757 18.6157 10.3954 18.8816 10.1703L20.4344 8.85268C20.0838 7.91466 19.5788 7.04184 18.9404 6.27028L17.0252 6.95428C16.6975 7.0713 16.3483 7.11566 16.0017 7.08428C15.6552 7.05291 15.3196 6.94656 15.0182 6.77259C14.7169 6.59862 14.457 6.36121 14.2565 6.0768C14.056 5.79238 13.9198 5.46778 13.8572 5.12548L13.49 3.12268C12.5028 2.95809 11.4952 2.95809 10.508 3.12268L10.1432 5.12548C10.0808 5.46789 9.94469 5.79262 9.74427 6.07718C9.54386 6.36173 9.28395 6.59928 8.98257 6.77338C8.6812 6.94747 8.34556 7.05393 7.99894 7.08537C7.65232 7.11682 7.303 7.07249 6.97522 6.95548L5.05882 6.27028C4.42045 7.04185 3.9155 7.91467 3.56482 8.85268ZM8.99962 12.0003C8.99962 11.2046 9.31569 10.4416 9.87829 9.87896C10.4409 9.31635 11.204 9.00028 11.9996 9.00028C12.7953 9.00028 13.5583 9.31635 14.1209 9.87896C14.6835 10.4416 14.9996 11.2046 14.9996 12.0003C14.9996 12.7959 14.6835 13.559 14.1209 14.1216C13.5583 14.6842 12.7953 15.0003 11.9996 15.0003C11.204 15.0003 10.4409 14.6842 9.87829 14.1216C9.31569 13.559 8.99962 12.7959 8.99962 12.0003ZM10.1996 12.0003C10.1996 12.4777 10.3893 12.9355 10.7268 13.2731C11.0644 13.6106 11.5222 13.8003 11.9996 13.8003C12.477 13.8003 12.9348 13.6106 13.2724 13.2731C13.61 12.9355 13.7996 12.4777 13.7996 12.0003C13.7996 11.5229 13.61 11.0651 13.2724 10.7275C12.9348 10.3899 12.477 10.2003 11.9996 10.2003C11.5222 10.2003 11.0644 10.3899 10.7268 10.7275C10.3893 11.0651 10.1996 11.5229 10.1996 12.0003Z"
                fill="#E1EBF8" stroke="#E1EBF8" stroke-width="2" mask="url(#path-1-inside-1_1733_6915)"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <table class="main-table">
      <thead v-if="type === 'rows'">
      <draggable v-model="headers" tag="tr" @change="saveSettings">
        <template v-for="header in headers">
          <td class="sortable" @click="set_sort(header.key)" :key="header.key" scope="col"
              v-if="showHeaders[header.key]">
            {{ $vuetify.lang.t('$vuetify.' + header.name) }}
            <v-icon class="sorts__icon" v-if="sort.includes(header.key)" :class="{reverse: sort[0] === '-'}">
              mdi-arrow-up
            </v-icon>
          </td>
        </template>
      </draggable>
      </thead>
      <tbody :class="{ 'cards ': type === 'cards' }">
      <ClientCard v-for="(client) in clients" :key="client.id" :id="client.id" :photo="client.photo"
                  :options="client.options" :type="type" :active="client.active" :address="client.address"
                  :headers="headers"
                  @edit="
            (id) => {
              client_action = 'edit';
              chosen_id = id;
              client_create_open();
            }"
                  @archive=" ()=> {loadData()}">
      </ClientCard>
      </tbody>
    </table>
    <div class="page-footer">
      <per-page-select v-model="perPage"></per-page-select>
      <v-pagination
        v-model="page"
        :length="length"
        @input="loadData"
      ></v-pagination>
    </div>

    <v-dialog v-model="client_create_modal">
      <div class="modal">
        <div class="h1">
          <span v-if="client_action === 'add'"> {{ $vuetify.lang.t('$vuetify.addClient') }}</span>
          <span v-if="client_action === 'edit'"> {{ $vuetify.lang.t('$vuetify.editClient') }}</span>
        </div>
        <v-form ref="form" class="" v-if="client_create_step === 1" :key="1" @submit.prevent="check">
          <div class="h2">{{ $vuetify.lang.t('$vuetify.mainInfo') }}</div>
          <v-text-field :label="$vuetify.lang.t('$vuetify.name2')" v-model="newClient.name" outlined
                        :rules="[$rules.required]" @focusout="checkOrganization"></v-text-field>
          <v-text-field :label="$vuetify.lang.t('$vuetify.shortName')" v-model="newClient.short_name"
                        outlined></v-text-field>
          <v-combobox :label="$vuetify.lang.t('$vuetify.activityType')" v-model="newClient.branch" :items="branches"
                      outlined attach
                      :menu-props="{
                          bottom: true,
                          offsetY: true,
                          maxHeight: width<1024 ? 200 : 800,
                          contentClass: 'select-menu',
                        }"
                      :rules="[$rules.required]"></v-combobox>
          <v-text-field :label="$vuetify.lang.t('$vuetify.regNumber')" v-model="newClient.ogrn" outlined
                        :rules="[$rules.required]" @focusout="checkOrganization">
          </v-text-field>
          <div class="h2">{{ $vuetify.lang.t('$vuetify.menu.contacts') }}</div>
          <v-text-field :label="$vuetify.lang.t('$vuetify.phone')" v-model="newClient.phone" outlined
                        :rules="[$rules.required]"></v-text-field>
          <v-text-field label="Email" v-model="newClient.email" outlined
                        :rules="[$rules.required, $rules.email, $rules.notSpaces]">
          </v-text-field>
          <v-text-field :label="$vuetify.lang.t('$vuetify.website')" v-model="newClient.site" outlined></v-text-field>
          <v-text-field label="vat" v-model="newClient.vat" outlined :rules="[$rules.required]"></v-text-field>
          <div class="sign-up__buttons btn-group">
            <div class="btn btn-secondary" @click="client_create_close">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </div>
            <button class="btn btn-primary">{{ $vuetify.lang.t('$vuetify.forward') }}</button>
          </div>
        </v-form>
        <v-form ref="form" class="" v-if="client_create_step === 2" :key="2" @submit.prevent="uploadFile">
          <div class="h2">{{ $vuetify.lang.t('$vuetify.logo') }}</div>
          <v-file-input class="file-input" v-model="photo" accept=".jpg, .png, .jpeg"
                        :placeholder="$vuetify.lang.t('$vuetify.uploadImg')" prepend-icon="$photo">
          </v-file-input>

          <div class="h2">{{ $vuetify.lang.t('$vuetify.address') }}</div>
          <v-text-field v-model="newClient.business_address.street" class="address__street"
                        :label="$vuetify.lang.t('$vuetify.street')" outlined :rules="[$rules.required]"></v-text-field>
          <div class="form__row form__address">
            <v-text-field v-model="newClient.business_address.house" class="address__house"
                          :label="$vuetify.lang.t('$vuetify.house')" outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newClient.business_address.entrance" class="address__entrance"
                          :label="$vuetify.lang.t('$vuetify.entrance')" outlined></v-text-field>
            <v-text-field v-model="newClient.business_address.flat" class="address__flat"
                          :label="$vuetify.lang.t('$vuetify.flat')" outlined>
            </v-text-field>
          </div>
          <v-text-field v-model="newClient.business_address.index" class="address__index"
                        :label="$vuetify.lang.t('$vuetify.index')" outlined :rules="[$rules.required]"></v-text-field>
          <v-text-field v-model="newClient.business_address.city" class="address__city"
                        :label="$vuetify.lang.t('$vuetify.city')" outlined :rules="[$rules.required]"></v-text-field>
          <v-text-field v-model="newClient.business_address.country" class="address__country"
                        :label="$vuetify.lang.t('$vuetify.country')" outlined :rules="[$rules.required]"></v-text-field>

          <v-progress-linear :class="{form__progress : form_loader}"
                             :active="form_loader"
                             indeterminate
                             rounded
                             height="6"
          ></v-progress-linear>

          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <div class="btn btn-secondary" @click="client_create_step--">
              {{ $vuetify.lang.t('$vuetify.back') }}
            </div>
            <button class="btn btn-primary">
              <span v-if="client_action === 'add'">{{ $vuetify.lang.t('$vuetify.add') }}</span>
              <span v-if="client_action === 'edit'">{{ $vuetify.lang.t('$vuetify.edit') }}</span>
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>

    <v-dialog v-model="foundOrgModal">
      <div class="modal">
        <div class="h1">
          {{ $vuetify.lang.t("$vuetify.maybe") }}
        </div>
        <div class="flex flex-column">
          <button class="btn btn-secondary" v-for="org in foundOrg" :key="org.id"
                  @click="selectCompany(org)">
            {{ org.name }}
          </button>
          <button class="btn btn-primary" @click="foundOrgModal = false">
            {{ $vuetify.lang.t('$vuetify.cancel') }}
          </button>
        </div>
      </div>
    </v-dialog>

    <SpinnerLoader :overlay="loader"></SpinnerLoader>

    <v-dialog v-model="settingsModal">
      <div class="modal">
        <div class="h1">
          {{ $vuetify.lang.t("$vuetify.selectShownHeaders") }}
        </div>
        <v-form ref="form" @submit.prevent="">
          <v-checkbox v-for="header in headers" v-model="showHeaders[header.key]" :key="header.key"
                      :label="$vuetify.lang.t('$vuetify.' + header.name)"></v-checkbox>
          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-secondary" @click="settingsModal=false">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="saveSettings">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>

  </div>
</template>
<script>
import ClientCard from "./parts/ClientCard.vue";
import SpinnerLoader from "@/components/SpinnerLoader";
import draggable from 'vuedraggable';
import PerPageSelect from "@/components/PerPageSelect.vue";
import {mapActions, mapGetters} from "vuex";

class Option {
  constructor(value, name = "unnamed", icon = "") {
    this.value = value;
    this.name = name;
    this.icon = icon;
  }
}

export default {
  name: "clients-list",
  components: {
    PerPageSelect,
    ClientCard,
    SpinnerLoader,
    draggable,
  },

  data: function () {
    return {
      type: localStorage.getItem("type_clients") ?? (window.screen.width < 600 ? "cards" : "cards"),
      arch: false,
      sort: 'name',
      search: '',
      page: 1,
      perPage: Number(localStorage.getItem("per_page") ?? 24),
      length: 0,
      selectSorts: [
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byName') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
          type: "byName",
          direction: "sortAscending",
          value: 'name'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byName') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
          type: "byName",
          direction: "sortDescending",
          value: '-name'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
          type: "byCreateDate",
          direction: "sortAscending",
          value: 'create_date'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
          type: "byCreateDate",
          direction: "sortDescending",
          value: '-create_date'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byBranch') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
          type: "byBranch",
          direction: "sortAscending",
          value: 'branch'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byBranch') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
          type: "byBranch",
          direction: "sortDescending",
          value: '-branch'
        },
      ],
      headers: [
        {key: "name", name: 'companyName'},
        {key: "branch", name: 'activityType'},
        {key: "phone", name: 'phone'},
        {key: "email", name: 'email'},
        {key: "ogrn", name: 'regNumber'},
      ],

      tmp: false,

      chosen_id: "",
      client_action: "add",
      client_create_modal: false,
      client_create_step: 1,
      row_clients: [],
      obj_works: [],
      obj_work: "",

      clients: [],
      branches: [],

      newClient: {
        business_address: {},
      },
      photo: null,
      foundOrg: [],
      foundOrgModal: false,

      alertMsg: "",
      alertError: false,
      loader: false,
      form_loader: false,

      settingsModal: false,
      tableSettings: {},
      showHeaders: {},
      width: screen.width,
    };
  },

  created: function () {
    this.checkPermission('Клиенты').then(() => {
      this.loadData();
      this.loadSettings();
    });
  },

  methods: {
    ...mapActions(['checkPermission']),
    loadData: function () {
      this.loader = true
      this.$axios({
        url: this.$hostname + "time-tracking/clients",
        method: "get",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          arch: !this.arch,
          sort: this.sort,
          search: this.search,
          page: this.page,
          per: this.perPage,
        }
      }).then((response) => {
        if (response.data.data.data) {
          this.length = response.data.data.pages
          this.clients = [];
          this.row_clients = response.data.data.data;
          response.data.data.data.forEach((element) => {
            this.clients.push({
              id: element.id,
              photo: element.logo_path,
              active: element.active,
              address: element.business_address.street + '+' + element.business_address.house + '+' + element.business_address.city,
              options: {
                array: [
                  new Option(element.name),
                  new Option(element.branch),
                  new Option(
                    '<a href="tel:' + element.phone.replace(/\D/g, '') + '">' + element.phone + '</a>',
                    "phone",
                    '<svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.8 14.8004C4.64087 14.8004 4.48826 14.8636 4.37574 14.9761C4.26321 15.0886 4.2 15.2413 4.2 15.4004C4.2 15.5595 4.26321 15.7121 4.37574 15.8247C4.48826 15.9372 4.64087 16.0004 4.8 16.0004H7.2C7.35913 16.0004 7.51174 15.9372 7.62426 15.8247C7.73679 15.7121 7.8 15.5595 7.8 15.4004C7.8 15.2413 7.73679 15.0886 7.62426 14.9761C7.51174 14.8636 7.35913 14.8004 7.2 14.8004H4.8Z" fill="#2C1521"/><path d="M2.4 0.400391C1.76348 0.400391 1.15303 0.653247 0.702944 1.10333C0.252856 1.55342 0 2.16387 0 2.80039V17.2004C0 17.8369 0.252856 18.4474 0.702944 18.8974C1.15303 19.3475 1.76348 19.6004 2.4 19.6004H9.6C10.2365 19.6004 10.847 19.3475 11.2971 18.8974C11.7471 18.4474 12 17.8369 12 17.2004V2.80039C12 2.16387 11.7471 1.55342 11.2971 1.10333C10.847 0.653247 10.2365 0.400391 9.6 0.400391H2.4ZM1.2 2.80039C1.2 2.48213 1.32643 2.17691 1.55147 1.95186C1.77652 1.72682 2.08174 1.60039 2.4 1.60039H9.6C9.91826 1.60039 10.2235 1.72682 10.4485 1.95186C10.6736 2.17691 10.8 2.48213 10.8 2.80039V17.2004C10.8 17.5187 10.6736 17.8239 10.4485 18.0489C10.2235 18.274 9.91826 18.4004 9.6 18.4004H2.4C2.08174 18.4004 1.77652 18.274 1.55147 18.0489C1.32643 17.8239 1.2 17.5187 1.2 17.2004V2.80039Z" fill="#2C1521"/></svg>'
                  ),
                  new Option(
                    '<a href="mailto:' + element.email + '">' + element.email + '</a>',

                    "email",
                    '<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.6004 0.799805C17.396 0.799805 18.1591 1.11588 18.7217 1.67848C19.2843 2.24109 19.6004 3.00416 19.6004 3.7998V13.3998C19.6004 14.1955 19.2843 14.9585 18.7217 15.5211C18.1591 16.0837 17.396 16.3998 16.6004 16.3998H3.40039C2.60474 16.3998 1.84168 16.0837 1.27907 15.5211C0.716461 14.9585 0.400391 14.1955 0.400391 13.3998V3.7998C0.400391 3.00416 0.716461 2.24109 1.27907 1.67848C1.84168 1.11588 2.60474 0.799805 3.40039 0.799805H16.6004ZM18.4004 5.553L10.3052 10.317C10.2287 10.3619 10.1431 10.3893 10.0547 10.3972C9.96631 10.4051 9.87727 10.3933 9.79399 10.3626L9.69559 10.317L1.60039 5.5554V13.3998C1.60039 13.8772 1.79003 14.335 2.1276 14.6726C2.46516 15.0102 2.923 15.1998 3.40039 15.1998H16.6004C17.0778 15.1998 17.5356 15.0102 17.8732 14.6726C18.2107 14.335 18.4004 13.8772 18.4004 13.3998V5.553ZM16.6004 1.9998H3.40039C2.923 1.9998 2.46516 2.18945 2.1276 2.52701C1.79003 2.86458 1.60039 3.32242 1.60039 3.7998V4.1622L10.0004 9.10381L18.4004 4.15981V3.7998C18.4004 3.32242 18.2107 2.86458 17.8732 2.52701C17.5356 2.18945 17.0778 1.9998 16.6004 1.9998Z" fill="#2C1521"/></svg>'
                  ),
                  new Option(
                    element.ogrn,
                    "ogrn",
                    '<svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.00078 6.40039C4.84165 6.40039 4.68904 6.4636 4.57652 6.57613C4.464 6.68865 4.40078 6.84126 4.40078 7.00039C4.40078 7.15952 4.464 7.31213 4.57652 7.42465C4.68904 7.53718 4.84165 7.60039 5.00078 7.60039H11.0008C11.1599 7.60039 11.3125 7.53718 11.425 7.42465C11.5376 7.31213 11.6008 7.15952 11.6008 7.00039C11.6008 6.84126 11.5376 6.68865 11.425 6.57613C11.3125 6.4636 11.1599 6.40039 11.0008 6.40039H5.00078ZM4.40078 10.6004C4.40078 10.4413 4.464 10.2886 4.57652 10.1761C4.68904 10.0636 4.84165 10.0004 5.00078 10.0004H10.6048C10.4728 10.376 10.4008 10.7804 10.4008 11.2004H5.00078C4.84165 11.2004 4.68904 11.1372 4.57652 11.0247C4.464 10.9121 4.40078 10.7595 4.40078 10.6004ZM14.0008 3.40039V7.60039C14.4208 7.60039 14.8252 7.67239 15.2008 7.80559V3.40039C15.2008 2.923 15.0111 2.46516 14.6736 2.1276C14.336 1.79003 13.8782 1.60039 13.4008 1.60039H12.8008V1.00039C12.8008 0.841261 12.7376 0.688648 12.625 0.576127C12.5125 0.463605 12.3599 0.400391 12.2008 0.400391C12.0417 0.400391 11.889 0.463605 11.7765 0.576127C11.664 0.688648 11.6008 0.841261 11.6008 1.00039V1.60039H8.60078V1.00039C8.60078 0.841261 8.53757 0.688648 8.42505 0.576127C8.31252 0.463605 8.15991 0.400391 8.00078 0.400391C7.84165 0.400391 7.68904 0.463605 7.57652 0.576127C7.46399 0.688648 7.40078 0.841261 7.40078 1.00039V1.60039H4.40078V1.00039C4.40078 0.841261 4.33757 0.688648 4.22505 0.576127C4.11252 0.463605 3.95991 0.400391 3.80078 0.400391C3.64165 0.400391 3.48904 0.463605 3.37652 0.576127C3.264 0.688648 3.20078 0.841261 3.20078 1.00039V1.60039H2.60078C2.12339 1.60039 1.66555 1.79003 1.32799 2.1276C0.990423 2.46516 0.800781 2.923 0.800781 3.40039V17.8004C0.800781 18.2778 0.990423 18.7356 1.32799 19.0732C1.66555 19.4107 2.12339 19.6004 2.60078 19.6004H8.90078C8.64526 19.2297 8.44138 18.826 8.29478 18.4004H2.60078C2.44165 18.4004 2.28904 18.3372 2.17652 18.2247C2.064 18.1121 2.00078 17.9595 2.00078 17.8004V3.40039C2.00078 3.24126 2.064 3.08865 2.17652 2.97613C2.28904 2.8636 2.44165 2.80039 2.60078 2.80039H13.4008C13.5599 2.80039 13.7125 2.8636 13.825 2.97613C13.9376 3.08865 14.0008 3.24126 14.0008 3.40039ZM5.00078 13.6004C4.84165 13.6004 4.68904 13.6636 4.57652 13.7761C4.464 13.8886 4.40078 14.0413 4.40078 14.2004C4.40078 14.3595 4.464 14.5121 4.57652 14.6247C4.68904 14.7372 4.84165 14.8004 5.00078 14.8004H7.40078C7.55991 14.8004 7.71252 14.7372 7.82505 14.6247C7.93757 14.5121 8.00078 14.3595 8.00078 14.2004C8.00078 14.0413 7.93757 13.8886 7.82505 13.7761C7.71252 13.6636 7.55991 13.6004 7.40078 13.6004H5.00078ZM16.4008 11.2004C16.4111 10.879 16.3567 10.5588 16.2409 10.2588C16.1251 9.95886 15.9502 9.68522 15.7265 9.45416C15.5029 9.22311 15.2351 9.03935 14.9391 8.9138C14.643 8.78825 14.3248 8.72348 14.0032 8.72332C13.6817 8.72315 13.3633 8.78761 13.0672 8.91286C12.771 9.03812 12.5031 9.22161 12.2792 9.45244C12.0553 9.68327 11.8801 9.95673 11.764 10.2566C11.6479 10.5564 11.5932 10.8766 11.6032 11.198C11.6226 11.8211 11.8836 12.4122 12.3311 12.8462C12.7786 13.2801 13.3774 13.523 14.0008 13.5233C14.6242 13.5236 15.2232 13.2814 15.6712 12.8478C16.1191 12.4143 16.3808 11.8235 16.4008 11.2004ZM9.20078 16.6004C9.20078 16.8068 9.21278 17.0072 9.23918 17.2004C9.35768 18.2001 9.86669 19.1125 10.6552 19.7384C11.5444 20.4524 12.7372 20.8004 14.0008 20.8004C15.2644 20.8004 16.4572 20.4524 17.3464 19.7384C18.2488 19.0124 18.8008 17.9396 18.8008 16.6004C18.8008 16.123 18.6111 15.6652 18.2736 15.3276C17.936 14.99 17.4782 14.8004 17.0008 14.8004H11.0008C10.5234 14.8004 10.0656 14.99 9.72799 15.3276C9.39042 15.6652 9.20078 16.123 9.20078 16.6004Z" fill="#2C1521"/></svg>'
                  ),
                  new Option(
                    (element.business_address.street + ' ' + element.business_address.house + (element.business_address.entrance ? (' ' + element.business_address.entrance + ' ') : '') + (element.business_address.flat ? (' ' + element.business_address.flat + ', ') : ', ') + element.business_address.index + ' ' + element.business_address.city + ', ' + element.business_address.country),
                    "address",
                    '<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.79721 0.865346C8.12759 0.568506 8.55606 0.404297 9.00021 0.404297C9.44436 0.404297 9.87282 0.568506 10.2032 0.865346L16.8032 6.79575C16.9909 6.9645 17.1409 7.17082 17.2437 7.40133C17.3464 7.63184 17.3996 7.88138 17.3996 8.13375V16.5997C17.3996 17.0771 17.21 17.535 16.8724 17.8725C16.5348 18.2101 16.077 18.3997 15.5996 18.3997H12.5996C12.1222 18.3997 11.6644 18.2101 11.3268 17.8725C10.9893 17.535 10.7996 17.0771 10.7996 16.5997V12.3997C10.7996 12.2406 10.7364 12.088 10.6239 11.9755C10.5114 11.863 10.3587 11.7997 10.1996 11.7997H7.79961C7.64048 11.7997 7.48787 11.863 7.37535 11.9755C7.26282 12.088 7.19961 12.2406 7.19961 12.3997V16.5997C7.19961 17.0771 7.00997 17.535 6.6724 17.8725C6.33484 18.2101 5.877 18.3997 5.39961 18.3997H2.39961C1.92222 18.3997 1.46438 18.2101 1.12682 17.8725C0.789252 17.535 0.599609 17.0771 0.599609 16.5997V8.13375C0.599609 7.62375 0.815609 7.13775 1.19721 6.79575L7.79721 0.865346ZM9.40041 1.75815C9.29031 1.65931 9.14757 1.60464 8.99961 1.60464C8.85165 1.60464 8.70891 1.65931 8.59881 1.75815L1.99881 7.68855C1.93629 7.74467 1.88625 7.8133 1.85193 7.88999C1.81762 7.96668 1.79979 8.04973 1.79961 8.13375V16.5997C1.79961 16.7589 1.86282 16.9115 1.97535 17.024C2.08787 17.1365 2.24048 17.1997 2.39961 17.1997H5.39961C5.55874 17.1997 5.71135 17.1365 5.82387 17.024C5.9364 16.9115 5.99961 16.7589 5.99961 16.5997V12.3997C5.99961 11.9224 6.18925 11.4645 6.52682 11.127C6.86438 10.7894 7.32222 10.5997 7.79961 10.5997H10.1996C10.677 10.5997 11.1348 10.7894 11.4724 11.127C11.81 11.4645 11.9996 11.9224 11.9996 12.3997V16.5997C11.9996 16.7589 12.0628 16.9115 12.1753 17.024C12.2879 17.1365 12.4405 17.1997 12.5996 17.1997H15.5996C15.7587 17.1997 15.9114 17.1365 16.0239 17.024C16.1364 16.9115 16.1996 16.7589 16.1996 16.5997V8.13375C16.1994 8.04973 16.1816 7.96668 16.1473 7.88999C16.113 7.8133 16.0629 7.74467 16.0004 7.68855L9.40041 1.75815Z" fill="#2C1521"/></svg>'
                  ),
                  new Option(
                    "<a href='" + (element.site ? (element.site.indexOf('http') === 0 ? element.site : ('//' + element.site)) : '') + "'>" + (element.site ? element.site : '') + "</a>",
                    "site",
                    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9ZM16.8 9C16.8 10.9778 15.7985 13.0015 14.4 14.4C13.0015 15.7985 10.9778 16.8 9 16.8C7.02224 16.8 4.99849 15.7985 3.6 14.4C2.20151 13.0015 1.2 10.9778 1.2 9C1.2 7.02224 2.20151 4.99849 3.6 3.6C4.99849 2.20151 7.02224 1.2 9 1.2C10.9778 1.2 13.0015 2.20151 14.4 3.6C15.7985 4.99849 16.8 7.02224 16.8 9Z" fill="#2C1521"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.14286 9.00001C5.14286 13.6512 6.67646 17.4857 9 17.4857C11.3235 17.4857 12.8571 13.6512 12.8571 9.00001C12.8571 4.34881 11.3235 0.514291 9 0.514291C6.67646 0.514291 5.14286 4.34881 5.14286 9.00001ZM11.6603 9.00001C11.6603 12.8695 10.0851 16.29 9 16.29C7.91486 16.29 6.34028 12.8695 6.34028 9.00001C6.34028 5.13052 7.91486 1.71001 9 1.71001C10.0851 1.71001 11.6603 5.13052 11.6603 9.00001Z" fill="#2C1521"/><path d="M2.41908 4.3375L3.45383 3.19373C3.55668 3.2863 3.6688 3.37887 3.78811 3.46835C5.09543 4.44755 7.1824 5.39 9.46068 5.39C11.4057 5.39 13.217 4.61315 14.5326 3.86127C14.8494 3.68024 15.1312 3.48378 15.375 3.27498L16.3768 4.44858C16.0579 4.72115 15.6969 4.97315 15.2989 5.19944C13.7395 6.09224 11.6639 6.59418 9.46068 6.59418C6.86663 6.59418 4.45669 5.89681 2.8624 4.70264C2.7091 4.5878 2.56117 4.46596 2.41908 4.3375Z" fill="#2C1521"/><path d="M2.41908 13.679L3.45383 14.8227C3.55668 14.7291 3.6688 14.6376 3.78811 14.5481C5.09543 13.5689 7.1824 12.61 9.46068 12.61C11.4057 12.61 13.217 13.4033 14.5326 14.1552C14.8494 14.3362 15.1312 14.5327 15.375 14.7415L16.3768 13.5679C16.0417 13.2845 15.6808 13.0331 15.2989 12.817C13.7395 11.9242 11.6639 11.4223 9.46068 11.4223C6.86663 11.4223 4.45669 12.1196 2.8624 13.3138C2.7091 13.4287 2.56117 13.5505 2.41908 13.679Z" fill="#2C1521"/><path d="M1 9.6V8.4H17V9.6H1Z" fill="#2C1521"/></svg>'
                  ),
                ],
                name: element.name,
                branch: element.branch,
                phone: '<a href="tel:' + element.phone.replace(/\D/g, '') + '">' + element.phone + '</a>',
                email: '<a href="mailto:' + element.email + '">' + element.email + '</a>',
                ogrn: element.ogrn,
              },
            });
          });
        }
      }).catch((err) => {
        this.alertMsg = this.$catch(err);
        this.alertError = true;
      }).then(() => {
        this.loader = false
      })
    },
    loadBranches() {
      this.$axios({
        url: this.$hostname + "time-tracking/clients/branches",
        method: "GET",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      })
        .then((response) => {
          this.branches = response.data.data.branches;
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    loadSettings() {
      this.$axios({
        url: this.$hostname + "time-tracking/user-settings/table-settings",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.tableSettings = response.data.data.data
        if (response.data.data.data && response.data.data.data.clients) {
          this.showHeaders = response.data.data.data.clients
        } else
          this.showHeaders = {
            name: true,
            branch: true,
            email: true,
            phone: true,
            ogrn: true
          }

        let order = []
        this.headers.forEach(header => {
          order.splice(this.showHeaders.order.indexOf(header.key), 0, header)
        })
        this.headers = order
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    confirmClient() {
      if (this.$refs.form.validate()) {
        this.form_loader = true
        if (this.client_action === "add") {
          this.addClient();
        } else {
          this.editClient();
        }
      } else {
        this.alertMsg = "Заполните все необходимые данные";
        this.alertError = true;
      }
    },

    uploadFile() {
      if (this.$refs.form.validate()) {
        this.form_loader = true
        if (this.photo != null) {
          this.$axios({
            url: this.$hostname + "time-tracking/images/upload/clients",
            method: "POST",
            headers: {
              "Content-Type": "multipart/form-data",
            },
            data: {
              file: this.photo,
            },
          }).then((response) => {
            this.newClient.logo_path = response.data.data;
            this.confirmClient()
          }).catch((error) => {
            alert("Ошибка загрузки файла: " + error.message);
          });
        } else {
          this.confirmClient()
        }
      } else {
        this.alertMsg = "Заполните все необходимые данные";
        this.alertError = true;
      }
    },

    addClient() {
      this.$axios
        .post(
          this.$hostname + "time-tracking/clients",
          {
            name: this.newClient.name,
            short_name: this.newClient.short_name,
            ogrn: this.newClient.ogrn,
            business_address: JSON.stringify(
              this.newClient.business_address
            ),
            phone: this.newClient.phone,
            email: this.newClient.email.toLowerCase().replace(" ", ""),
            site: this.newClient.site,
            vat: this.newClient.vat,
            branch: this.newClient.branch,
            logo_path: this.newClient.logo_path ?? "",
            active: true,
            organization: JSON.parse(localStorage.getItem('organization')).id,
          },
          {
            headers: {
              Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
              "Content-Type": "multipart/form-data",
            },
          }
        ).then(() => {
        this.client_create_close();
        this.loadData();
      }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      }).then(() => {
        this.form_loader = false
      })
    },
    editClient() {
      this.$axios
        .put(
          this.$hostname + "time-tracking/clients",
          {
            id: this.chosen_id,
            name: this.newClient.name,
            short_name: this.newClient.short_name,
            ogrn: this.newClient.ogrn,
            business_address: JSON.stringify(this.newClient.business_address),
            phone: this.newClient.phone,
            email: this.newClient.email.toLowerCase().replace(" ", ""),
            site: this.newClient.site,
            vat: this.newClient.vat,
            branch: this.newClient.branch,
            logo_path: this.newClient.logo_path ?? "",
          },
          {
            headers: {
              Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
              "Content-Type": "multipart/form-data",
            },
          }
        ).then(() => {
        this.client_create_close();
        this.loadData();
      }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      }).then(() => {
        this.form_loader = false
      })
    },
    client_create_open() {
      this.loadBranches();
      this.client_create_step = 1;
      this.client_create_modal = true;
      this.photo = null

      if (this.client_action === "edit") {
        let tmp_client = this.row_clients.filter((c) => {
          return c.id == this.chosen_id;
        })[0];
        this.newClient = {
          name: tmp_client.name,
          short_name: tmp_client.short_name,
          ogrn: tmp_client.ogrn,
          phone: tmp_client.phone,
          email: tmp_client.email.toLowerCase().replace(" ", ""),
          site: tmp_client.site,
          vat: tmp_client.vat,
          branch: tmp_client.branch,
          logo_path: tmp_client.logo_path ?? "",
          active: true
        };
        this.newClient.business_address = tmp_client.business_address;
      } else {
        this.newClient = {
          business_address: {},
        };
      }
    },
    client_create_close() {
      this.client_create_modal = false;
      this.newClient = {
        business_address: {},
      }
      this.$refs.form.resetValidation()
    },
    selectCompany(org) {
      this.foundOrgModal = false
      this.newClient.name = org.name
      this.newClient.ogrn = org.ogrn
      this.newClient.phone = org.phone
      this.newClient.email = org.email
      this.newClient.site = org.site
      this.loader = true
      this.$axios({
        url: this.$hostname + "time-tracking/partner",
        method: "POST",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          organization: JSON.parse(localStorage.getItem('organization')).id,
          partner: org.id,
        }
      }).then(() => {
        this.client_create_close()
        this.loadData()
      }).catch((err) => {
        this.alertMsg = this.$catch(err);
        this.alertError = true;
        this.loader = false
      })
    },

    saveSettings() {
      let order = []
      this.headers.forEach(header => {
        order.push(header.key)
      })
      this.showHeaders.order = order
      this.tableSettings.clients = this.showHeaders
      this.$axios({
        url: this.$hostname + "time-tracking/user-settings/table-settings",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          table_settings: JSON.stringify(this.tableSettings)
        }
      }).then(() => {
        this.settingsModal = false
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    check() {
      if (this.$refs.form.validate()) {
        this.client_create_step++;
      }
    },
    checkOrganization() {
      this.loader = true
      this.$axios({
        url: this.$hostname + "time-tracking/check-organization",
        method: "get",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          name: this.newClient.name,
          ogrn: this.newClient.ogrn,
        }
      }).then((response) => {
        if (response.data.data.data && response.data.data.data.length) {
          this.foundOrg = response.data.data.data
          this.foundOrgModal = true
        }
      }).catch((err) => {
        this.alertMsg = this.$catch(err);
        this.alertError = true;
      }).finally(() => {
        this.loader = false
      })
    },

    set_sort(field) {
      if (this.sort.includes(field) && this.sort[0] !== '-') {
        this.sort = '-' + field
      } else {
        this.sort = field
      }
    },
  },

  watch: {
    type: function () {
      localStorage.setItem("type_clients", this.type);
    },
    sort: function () {
      this.loadData()
    },
    arch: function () {
      this.loadData()
    },
    perPage: function () {
      if ((this.page * this.perPage) > (this.page * this.clients.length))
        this.page = 1
      this.loadData()
    },
  },

  computed: {
    ...mapGetters(['permissions'])
  }
};
</script>
